export const Marquee = ({ items, testid = "editorial-marquee" }) => {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y hairline py-8 md:py-10 bg-[#0c1019]" data-testid={testid}>
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-display text-5xl md:text-7xl ${i % 2 ? "outline-text italic" : "text-slate-100"}`}>{t}</span>
            <span className="w-2.5 h-2.5 rotate-45 bg-[var(--gold)]" />
          </span>
        ))}
      </div>
    </div>
  );
};
